import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { CaretakerUpdateInputForm, FamilyResponse, FamilyUpdateRequest, PatientUpdateInputForm } from "../types/FamilyTypes";
import { getFamilyById, updateFamily } from "../services/familyService";
import "../styles/form.css";
import "../styles/update.css";

const FamilyDetail = () => {
  const { id } = useParams<{ id: string }>();
  const familyId = Number(id!);
  const [patient, setPatient] = useState<PatientUpdateInputForm>({
    id: 0,
    firstName: "",
    lastName: "",
    phoneNumber: ""
  });

  const [caretaker, setCaretaker] = useState<CaretakerUpdateInputForm>({
    id: 0,
    phoneNumber: ""
  });


  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFamily = async () => {
      try {
        const res = await getFamilyById(id!);
        if (res === null)
        {
          throw ": Family does not exist";
        }

        const patientData = res.members.find(x => x.isPatient);
        const caretakerData = res.members.find(x => !x.isPatient);

        setPatient({
          id: patientData!.id,
          firstName: patientData!.firstName,
          lastName: patientData!.lastName,
          phoneNumber: patientData!.phoneNumber
        })

        setCaretaker({
          id: caretakerData!.id,
          phoneNumber: caretakerData!.phoneNumber
        })
      } catch (error) {
        console.error("Failed to load family", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchFamily();
  }, [id]);


  
  const handleMemberChange = (memberType: string, e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    if (memberType === "patient") {
      setPatient({...patient, [e.target.name]: e.target.value})
    }
    else if (memberType === "caretaker") {
      setCaretaker({...caretaker, [e.target.name]: e.target.value})
    }
  };

  const handleFamlySubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!patient!.firstName || !patient!.lastName || !patient!.phoneNumber || !caretaker!.phoneNumber) {
      alert("Please fill in all required fields.");
      return;
    }

    const updatedFamily: FamilyUpdateRequest = {
      id: familyId,
      familyName: `${patient!.firstName} ${patient!.lastName}`,
      members: [
        {
          id: patient!.id,
          isPatient: true,
          firstName: patient!.firstName,
          lastName: patient!.lastName,
          phoneNumber: patient!.phoneNumber,
        },
        {
          id: caretaker!.id,
          isPatient: false,
          firstName: `(Caretaker)${patient!.firstName}`,
          lastName: `(Caretaker)${patient!.lastName}`,
          phoneNumber: caretaker!.phoneNumber
        }
      ]
    };

    const response = await updateFamily(updatedFamily);
    if (response) {
      setPatient({
        id: 0,
        firstName: "",
        lastName: "",
        phoneNumber: "",
      })

      setCaretaker({
        id: 0,
        phoneNumber: ""
      })
      alert("Family updated successfully!");
      navigate("/family");
    } else {
      alert("Failed to update family");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!patient) return <p>Parent not found.</p>;
  if (!caretaker) return <p>Caretaker not found.</p>;
  if (id === undefined) {
    return <p>Family not found.</p>;
  }
  return (
    <div className="form-container update-form-container">
        <h2 className="text-xl font-bold mb-4">Edit Family</h2>
          <form onSubmit={handleFamlySubmit}>
            <div>
                <h3>Patient</h3>
                <div className="input-group">
                    <div className="input-row">
                        <input type="text" name="firstName" placeholder="First Name" value={patient.firstName} onChange={(e) => handleMemberChange("patient", e)} required />
                        <input type="text" name="lastName" placeholder="Last Name" value={patient.lastName} onChange={(e) => handleMemberChange("patient", e)} required />
                        <input type="text" name="phoneNumber" placeholder="Phone Number" value={patient.phoneNumber} onChange={(e) => handleMemberChange("patient", e)} required />
                    </div>
                </div>
                <h3>Caretaker</h3>
                <div className="input-group">
                    <div className="input-row caretaker-phone-number-field">
                      <input type="text" name="phoneNumber" placeholder="Phone Number" value={caretaker.phoneNumber} onChange={(e) => handleMemberChange("caretaker", e)} required />
                    </div>
                </div>
            </div>
    
            <button className="submit-button" type="submit">Submit</button>
          </form>

    </div>
  );
};

export default FamilyDetail;
